import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useStateAuthContext, useStateHostContext } from '../context'
import { Modal } from 'react-bootstrap'
import { success, error } from '../notify'
import { FaArrowLeft, FaFileInvoice } from "react-icons/fa"
import { BeatLoader } from 'react-spinners'

const Opd_kendaraan_pemeliharaan = () => {
  const { state } = useLocation()
  const { HOST } = useStateHostContext()
  const { STATE_AUTH } = useStateAuthContext()
  const navigate = useNavigate()

  const [showModal, setShowModal] = React.useState(false)
  const [dataPemeliharaan, setDataPemeliharaan] = React.useState([])
  const [tanggalPemeliharaan, setTanggalPemeliharaan] = React.useState('')
  const [uraian, setUraian] = React.useState('')
  const [satuan, setSatuan] = React.useState('')
  const [volume, setVolume] = React.useState('0')
  const [hargaSatuan, setHargaSatuan] = React.useState('')
  const [filePemeliharaan, setFilePemeliharaan] = React.useState(null)
  const [namaPptk, setNamaPptk] = React.useState('')
  const [loading, setLoading] = React.useState(false)

  const handleShow = () => setShowModal(true)
  const handleHide = () => setShowModal(false)

  const formatRupiah = (angka) => {
    if (!angka || isNaN(angka)) return 'Rp 0'
    return 'Rp ' + parseInt(angka, 10).toLocaleString('id-ID')
  }

  const formatTanggal = (tanggal) => {
    const tgl = new Date(tanggal)
    return tgl.toLocaleDateString('id-ID', { day: '2-digit', month: 'long', year: 'numeric' })
  }

  const ambilDataPemeliharaan = React.useCallback(async () => {
    setLoading(true)
    try {
      const res = await fetch(`${HOST}/user/kendaraan/pemeliharaan/detail/${state.id}`, {
        method: 'GET',
        headers: {
          "REST-ID-OPD": STATE_AUTH.id_opd,
          "REST-TOKEN": STATE_AUTH.token
        }
      })
      const data = await res.json()
      if (res.ok && data.s) {
        setDataPemeliharaan(data.d)
      } else {
        error({ msg: data.m || 'Gagal mengambil data' })
      }
    } catch (err) {
      error({ msg: err.message })
    } finally {
      setLoading(false)
    }
  }, [HOST, state.id, STATE_AUTH])

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!filePemeliharaan) {
      error({ msg: 'Harus mengupload file bukti pemeliharaan (PDF)' })
      return
    }

    const formData = new FormData()
    formData.append('ID_KENDARAAN', state.id)
    formData.append('ID_OPD', STATE_AUTH.id_opd)
    formData.append('TANGGAL_PEMELIHARAAN', tanggalPemeliharaan)
    formData.append('URAIAN', uraian)
    formData.append('VOLUME', volume)
    formData.append('SATUAN', satuan)
    formData.append('HARGA_SATUAN', hargaSatuan)
    formData.append('FILE_PEMELIHARAAN', filePemeliharaan)
    formData.append('NAMA_PPTK', namaPptk)

    setLoading(true)
    try {
      const res = await fetch(`${HOST}/user/kendaraan/pemeliharaan/simpan`, {
        method: 'POST',
        headers: {
          "REST-ID-OPD": STATE_AUTH.id_opd,
          "REST-TOKEN": STATE_AUTH.token
        },
        body: formData
      })
      const data = await res.json()
      if (res.ok && data.s) {
        success({ msg: data.m })
        handleHide()
        ambilDataPemeliharaan()
      } else {
        error({ msg: data.m })
      }
    } catch (err) {
      error({ msg: err.message })
    } finally {
      setLoading(false)
    }
  }

  React.useEffect(() => {
    ambilDataPemeliharaan()
  }, [ambilDataPemeliharaan])

  const jumlah = parseFloat(volume || 0) * parseFloat(hargaSatuan || 0)

  return (
    <main>
      <div className="container-fluid mt-3">
        <h3><strong><FaFileInvoice /> PEMELIHARAAN KENDARAAN</strong></h3>
        <hr />
        <div className="mb-3">
          <button className='btn btn-sm btn-warning me-2' onClick={() => navigate(-1)}>
            <FaArrowLeft /> Kembali
          </button>
          <button className='btn btn-sm btn-primary me-2' onClick={handleShow}>
            Tambah
          </button>
          <button className='btn btn-sm btn-success' onClick={() => window.open(`${HOST}/user/kendaraan/pemeliharaan/export/${state.id}`, '_blank')}>
            Export
          </button>
        </div>

        {/* Informasi Kendaraan */}
        <table className='table table-sm'>
          <tbody>
            <tr><td>Kode Barang</td><td>{state.kode_barang}</td></tr>
            <tr><td>Nomor Register</td><td>{state.nomor_register}</td></tr>
            <tr><td>Nama Barang</td><td>{state.nama_barang}</td></tr>
            <tr><td>Type Kendaraan</td><td>{state.merk_type}</td></tr>
            <tr><td>Nomor Polisi</td><td>{state.no_polisi}</td></tr>
          </tbody>
        </table>
        <hr />

        {/* Tabel Pemeliharaan */}
        <table className='tb-daftar-dinas mt-1'>
          <thead className='table-primary text-center'>
            <tr>
              <th>Tanggal</th>
              <th>Uraian</th>
              <th>Satuan</th>
              <th>Volume</th>
              <th>Harga Satuan</th>
              <th>Jumlah</th>
              <th>File / Bukti Pemeliharaan</th>
              <th>Nama PPTK</th>
            </tr>
          </thead>
          <tbody>
            {!loading ? (
              dataPemeliharaan.length === 0 ? (
                <tr><td colSpan={8} className='text-center'>Belum ada data pemeliharaan</td></tr>
              ) : (
                dataPemeliharaan.map((val, i) => (
                  <tr key={i}>
                    <td>{formatTanggal(val.tanggal_pemeliharaan)}</td>
                    <td>{val.uraian}</td>
                    <td className='text-center'>{val.satuan}</td>
                    <td className='text-center'>{val.volume}</td>
                    <td className='text-end'>{formatRupiah(val.harga_satuan)}</td>
                    <td className='text-end'>{formatRupiah(val.volume * val.harga_satuan)}</td>
                    <td className='text-center'>
                      {val.file_dokumentasi_pemeliharaan
                        ? <button className='btn btn-success btn-sm' onClick={() => window.open(val.file_dokumentasi_pemeliharaan, '_blank')}>Lihat</button>
                        : <span className='text-danger'>Tidak Ada</span>}
                    </td>
                    <td>{val.nama_pptk}</td>
                  </tr>
                ))
              )
            ) : (
              <tr>
                <td colSpan={8} className='text-center'><BeatLoader /></td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Modal Tambah Pemeliharaan */}
      <Modal show={showModal} centered backdrop="static" onHide={handleHide}>
        <Modal.Header closeButton>
          <Modal.Title>Tambah Pemeliharaan</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit}>
            <div className='form-group mb-2'>
              <input type='date' className='form-control form-control-sm' required
                value={tanggalPemeliharaan} onChange={e => setTanggalPemeliharaan(e.target.value)} />
            </div>
            <div className='form-group mb-2'>
              <textarea rows={3} placeholder='Uraian Pemeliharaan' className='form-control form-control-sm'
                value={uraian} onChange={e => setUraian(e.target.value)}></textarea>
            </div>
            <div className='form-group mb-2'>
              <input type='text' placeholder='Satuan' className='form-control form-control-sm' required
                value={satuan} onChange={e => setSatuan(e.target.value)} />
            </div>
            <div className='form-group mb-2'>
              <input type='number' placeholder='Volume' className='form-control form-control-sm' required
                value={volume} onChange={e => setVolume(e.target.value)} />
            </div>
            <div className='form-group mb-2'>
              <input type='number' placeholder='Harga Satuan' className='form-control form-control-sm' required
                value={hargaSatuan} onChange={e => setHargaSatuan(e.target.value)} />
            </div>
            <div className='form-group mb-2'>
              <input type='text' placeholder='Jumlah' className='form-control form-control-sm' readOnly
                value={formatRupiah(jumlah)} />
            </div>
            <div className='form-group mb-2'>
              <input type='text' placeholder='Nama PPTK' className='form-control form-control-sm' required
                value={namaPptk} onChange={e => setNamaPptk(e.target.value)} />
            </div>
            <div className='form-group mb-2'>
              <input type='file' accept='application/pdf' className='form-control form-control-sm' required
                onChange={e => setFilePemeliharaan(e.target.files[0])} />
              <small className='text-muted'>Hanya file PDF yang diterima</small>
            </div>
            {!loading ? (
              <button className='btn btn-primary btn-sm w-100'>Simpan</button>
            ) : (
              <button className="btn btn-primary btn-sm w-100" type="button" disabled>
                <span className="spinner-border spinner-border-sm me-2"></span> Mohon tunggu...
              </button>
            )}
          </form>
        </Modal.Body>
      </Modal>
    </main>
  )
}

export default Opd_kendaraan_pemeliharaan
